<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="my-backdrop"
      @click="onBackdrop"
    >
      <div
        class="my-modal"
        role="dialog"
        :aria-label="ariaLabel"
        @click.stop
      >
        <header class="my-header">
          <slot name="header"></slot>
        </header>

        <section class="my-body">
          <slot></slot>
        </section>

        <footer class="my-footer">
          <slot name="footer">
            <button @click="close">Close</button>
          </slot>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
// eslint-disable-next-line
const props = defineProps({
  modelValue: Boolean,
  closeOnBackdrop: { type: Boolean, default: true },
  ariaLabel: { type: String, default: '' }
})
// eslint-disable-next-line
const emit = defineEmits(['update:modelValue','close'])

const close = () => {
  emit('update:modelValue', false)
  emit('close')
}

const onBackdrop = () => {
  if (props.closeOnBackdrop) close()
}
</script>

<style scoped>
.my-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50000;
}

.my-modal {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  padding: 1rem;
  z-index: 50001;
}
</style>
